/* eslint-disable */
import { useLocation, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '../../Components/ui/card'
import { Button } from '../../Components/ui/button'
import { Label } from '../../Components/ui/label'
import { Input } from '../../Components/ui/input'
import { post } from '../../http/restservice'
import env from '../../env/env'
import { ChevronDown, ChevronLeft } from 'lucide-react'
import { useModal } from '../../hooks/use-modal-store'
import { MFTimeBasedBaskets } from '../../store/MFBasketsStore'
import { useRecoilValueLoadable } from 'recoil'

const Redeem = () => {
  const location = useLocation()
  console.log('🚀 ~ Redeem ~ location:', location.state)
  const navigate = useNavigate()
  const [amount, setAmount] = useState(location?.state?.payload?.orderInvestmentAmount || '')

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const { onOpen } = useModal()
  const baskets = useRecoilValueLoadable(MFTimeBasedBaskets)

  const educationConstituentsSIPWeightage = {
    'edutrg-gr': 0, // 10
    'edatgp-gr': 20,
    'pp001rg-gr': 25,
    'cmfcgp-gr': 20,
    'relsegp-gr': 25,
  }

  const weddingConstituentsWeightageSIP = {
    'edutrg-gr': 0, //10 Edelweiss US Technology Equity Fund of Fund
    'edmarg-gr': 20, // Edelweiss Multi Asset Allocation Fund-Reg(G)
    'rmfgdgp-gr': 10, // Nippon India Gold Savings Fund(G)
    'pp001rg-gr': 20, // Parag Parikh Flexi Cap Fund-Reg(G)
    earg: 20, // Nippon India Large Cap Fund
    dfg: 20, // ICICI Pru Value Discovery Fund(G)
  }

  const retirementConstituentsWeightageSIP = {
    'edutrg-gr': 0, // 20
    dynmic: 10,
    'pp001rg-gr': 15,
    'edatgp-gr': 10,
    'cmfcgp-gr': 25,
    'qumogp-gr': 20,
  }

  const oneToThreeYrConstituentsWeightage = {
    'km35-gr': 50, // Kotak Equity Savings
    'pp001rg-gr': 50, // Parag Parikh Flexi Cap Fund
  }

  const oneYrConstituentsWeightage = {
    'edatgp-gr': 50,
    'relmtf-gr': 50,
  }

  const emergencyConstituentsSIPWeightage = { 'edatgp-gr': 100 }

  const commoditiesConstituentsSIPWeightage = {
    'edgfrg-gr': 100,
  }

  const anytimeConstituentsWeightage = {
    'rmfgdgp-gr': 30, // Nippon Gold Fund
    'km35-gr': 70, // Kotak Equity Savings
  }

  // 12

  const threeToSixWithoutUsTechSIP = {
    'edatgp-gr': 20, // Edelweiss Multi Asset Allocation Fund-Reg(G)
    'pp001rg-gr': 25, // Parag Parikh Flexi Cap Fund-Reg(G)
    'cmfcgp-gr': 30,
    'relsegp-gr': 25, // Nippon India Large Cap Fund
  }

  const sixPlusWithoutUsTechSIP = {
    'edatgp-gr': 10, // Edelweiss Multi Asset Allocation Fund-Reg(G)
    'cmfcgp-gr': 30,
    'qumogp-gr': 30, // Quant Momentum Fund
    dynmic: 15, // ICICI Pru multi asset
    'pp001rg-gr': 15, // Parag Parikh Flexi Cap Fund-Reg(G)
  }

  const arbitrageSIP = {
    'edatgp-gr': 100,
  }

  const liquidSIP = {
    'rellftpi-gr': 100,
  }

  const cm = {
    'cmfcgp-gr': 100,
  }
  //16
  const oneTaxEfficient = {
    'edatgp-gr': 50,
    'rmfaf-gr': 50,
  }

  const basketOptions = {
    1: '6+ Retirement',
    2: '3-6 Education',
    3: '3-6 Wedding',
    4: '1-3',
    5: '1',
    6: 'Emergency',
    8: 'Commodities',
    10: 'Anytime',
    11: '6+_Retirement_Without_US_Tech',
    12: '3-6_Education_Without_US_Tech',
    13: 'Arbitrage',
    14: 'Liquid',
    15: 'CM',
    16: '1_Tax_Efficient',
    17: '1_Debt',
  }
  const universalBasketId =
    +location?.state?.basket[0]?.universalBasketId || +location?.state?.basket?.universalBasketId
  const basketName = basketOptions[universalBasketId]?.toLowerCase()

  const filteredConstituents =
    baskets?.state === 'hasValue'
      ? baskets?.contents?.data
          ?.filter((fund) => fund?.universalBasketId === universalBasketId)
          .map((fund) => ({
            ...fund,

            weightage:
              basketName == '6+ retirement'
                ? retirementConstituentsWeightageSIP[`${fund.bseSchemeCode.toLowerCase()}`]
                : basketName.includes('1_tax_efficient')
                ? oneTaxEfficient[`${fund.bseSchemeCode.toLowerCase()}`]
                : basketName.includes('cm')
                ? cm[schemeCode]
                : basketName == '6+_retirement_without_us_tech'
                ? sixPlusWithoutUsTechSIP[`${fund.bseSchemeCode.toLowerCase()}`]
                : basketName.includes('3-6_education_without_us_tech')
                ? threeToSixWithoutUsTechSIP[`${fund.bseSchemeCode.toLowerCase()}`]
                : basketName.includes('3-6 education')
                ? educationConstituentsSIPWeightage[`${fund.bseSchemeCode.toLowerCase()}`]
                : basketName.includes('wedding')
                ? weddingConstituentsWeightageSIP[`${fund.bseSchemeCode.toLowerCase()}`]
                : basketName.includes('1-3')
                ? oneToThreeYrConstituentsWeightage[`${fund.bseSchemeCode.toLowerCase()}`]
                : basketName.includes('emergency')
                ? emergencyConstituentsSIPWeightage[`${fund.bseSchemeCode.toLowerCase()}`]
                : basketName.includes('liquid')
                ? liquidSIP[`${fund.bseSchemeCode.toLowerCase()}`]
                : basketName.includes('arbitrage')
                ? arbitrageSIP[`${fund.bseSchemeCode.toLowerCase()}`]
                : basketName.includes('commodities')
                ? commoditiesConstituentsSIPWeightage[`${fund.bseSchemeCode.toLowerCase()}`]
                : basketName.includes('1')
                ? oneYrConstituentsWeightage[`${fund.bseSchemeCode.toLowerCase()}`]
                : anytimeConstituentsWeightage[`${fund.bseSchemeCode.toLowerCase()}`],
          }))
      : []

  // const minimumInvestmentAmount = filteredConstituents
  //   ? filteredConstituents.reduce((acc, fund) => acc + (Number(fund.minSip) || 0), 0)
  //   : 0

  const handleSubmit = async () => {
    setError('')

    // Basic validation
    if (!amount || isNaN(Number(amount)) || Number(amount) <= 0) {
      setError('Please enter a valid redemption amount')
      return
    }

    try {
      setIsLoading(true)

      const redemptionUrl = 'mutualfundservice/api/basket/redemptionFunds'

      const redemptionPayload = {
        customerBasketInvestmentId:
          location?.state?.basket[0]?.customerBasketInvestmentId ||
          location?.state?.basket?.customerBasketInvestmentId,
        universalBasketId: location?.state?.basket[0]?.universalBasketId || 1,
        withdrawableAmount: Number(amount),
      }

      const redemptionResponse = await post(`${env.API_URL}${redemptionUrl}`, redemptionPayload)

      const redemptionData = await redemptionResponse.json()
      setIsLoading(false)

      console.log('🚀 Redemption API response:', redemptionData)

      if (redemptionData?.status === 'SUCCESS') {
        onOpen('openAdminPopup', {
          title: 'Redemption Success!',
          message: 'Your redemption request has been successfully submitted.',
          severity: 'success',
        })
      } else {
        onOpen('openAdminPopup', {
          title: 'Redemption Failed!',
          message:
            redemptionData?.message ||
            'There was an issue with redemption. Please try again later.',
          severity: 'error',
        })
      }
    } catch (err) {
      setIsLoading(false)
      console.error('Redemption API Error:', err)
      onOpen('openAdminPopup', {
        title: 'Redemption Failed!',
        message: 'A technical error occurred while processing redemption. Please try again later.',
        severity: 'error',
      })
    }
  }

  return (
    <>
      <ChevronLeft onClick={() => navigate(-1)} className='cursor-pointer' />
      <div className='container flex items-center justify-center min-h-[70vh] py-12'>
        <Card className='w-full max-w-xl'>
          <CardHeader>
            <CardTitle className='text-2xl font-bold'>
              {location?.state?.basket[0]?.customerBasketName ||
                location?.state?.basket?.customerBasketName}{' '}
              - (SIP)
            </CardTitle>
            <CardDescription>
              Enter the amount you would like to redeem from your goal
            </CardDescription>
          </CardHeader>

          <CardContent>
            <div className='space-y-4'>
              <div className='space-y-2'>
                <Label htmlFor='amount' className='font-semibold'>
                  Redemption Amount
                </Label>
                <div className='relative'>
                  <Input
                    startAdornment='₹'
                    id='amount'
                    type='text'
                    placeholder='0'
                    className='pl-10'
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </div>
                {error && <p className='text-sm font-medium text-red-500'>{error}</p>}
              </div>

              <div className='flex justify-center items-center'>
                <Button
                  variant='link'
                  size='simple'
                  className='text-primary-500 p-0 border-b border-dashed border-primary-500 rounded-none hover:no-underline'
                  disabled={amount <= 0}
                  onClick={(e) => {
                    e.stopPropagation(),
                      onOpen('OpenAdminMFBreakdown', {
                        constituents: filteredConstituents,
                        amount: amount,
                      })
                  }}
                >
                  View detailed breakdown
                  <ChevronDown className='h-4 w-4 ml-1' />
                </Button>
              </div>
            </div>
          </CardContent>

          <CardFooter>
            <Button
              onClick={handleSubmit}
              type='submit'
              className='w-full disabled:bg-primary-300'
              disabled={isLoading || amount <= 0}
            >
              {isLoading ? 'Processing...' : 'Continue'}
            </Button>
          </CardFooter>
        </Card>
      </div>
    </>
  )
}

export default Redeem
